import { toggle } from "@otto-ec/global-resources/toggle";
import type { CustomElement } from "./utils";
import { extendElementAsFormAssociated } from "./extend.formAssociated";
import { extendElementWithInputBehavior } from "./extend.inputBehavior";
import { extendElementBase } from "./extend.base";
import { extendElementWithVisibilityInit } from "./extend.init.visibility";
import { extendElementWithRenderSliceInit } from "./extend.init.slice";
import type { CustomElementExtendOptions } from "./index.ts";
import { extendElementWithOcAutoAriaLabel } from "./extend.useOcAutoAriaLabel.ts";

export type ExtendToggles = [
  oc_init_with_render_slice: boolean,
  oc_init_with_visibility_threshold: boolean,
  oc_init_clear_shadow_on_disconnect: boolean,
  oc_init_attach_shadow_on_connect: boolean,
];
const toggles = (
  [
    ["oc_init_with_render_slice", false],
    ["oc_init_with_visibility_threshold", false],
    ["oc_init_clear_shadow_on_disconnect", false],
    ["oc_init_attach_shadow_on_connect", true],
  ] as const
).map(([tn, tv]) => toggle.get(tn, tv)) as ExtendToggles;

window.__components ??= {} as never;
window.__components.extend =
  /**
 *
 */
  (options: CustomElementExtendOptions = {}) =>
    /**
 *
 */
    (customElement) => {
      let result = extendElementBase(customElement as CustomElement, options);

      const { formAssociated, inputBehavior, asyncInit, visibilityInit, useOcAutoAriaLabel } =
        options;

      /*                                                */
      if (asyncInit && toggles[0]) {
        result = extendElementWithRenderSliceInit(result);
      }
      if (visibilityInit && toggles[1]) {
        result = extendElementWithVisibilityInit(result, toggles);
      }

      /*                                                               */
      if (formAssociated) result = extendElementAsFormAssociated(result);

      /*                                               */
      if (inputBehavior) result = extendElementWithInputBehavior(result);

      /*                          */
      if (useOcAutoAriaLabel) result = extendElementWithOcAutoAriaLabel(result);

      return result;
    };
